import React, { useEffect, useState } from "react";
import Card from './Card'
import './carousel.css'

const Carousel = ({ pacientes, seleccionarPaciente }) => {

  const carouselItems = document.querySelectorAll('.carousel__item');
  const elems = Array.from(carouselItems);

  const asignarPosiciones = (array) => {
    const length = array.length;
    const positions = [];

    if (length === 1) {
      positions.push(0);
    } else if (length === 2) {
      positions.push(0, 1);
    } else if (length === 3) {
      positions.push(0, 1, -1);
    } else if (length === 4) {
      positions.push(0, 1, -1, 'oculto');
    } else if (length === 5) {
      positions.push(0, 1, 2, -2, -1);
    } else if (length > 5) {
      positions.push(0, 1, 2);
      for (let i = 3; i < length - 2; i++) {
        positions.push('oculto');
      }
      positions.push(-2, -1);
    }

    for (let i = 0; i < length; i++) {
      array[i].pos = positions[i];
    }
    return array;
  }
  const [arrayCarrusel, setArrayCarrusel] = useState(asignarPosiciones(pacientes))
  const [seleccionado, setSeleccionado] = useState(arrayCarrusel[0].uid)
  
  const reasignarPosicion = (itemIndex, index) => {
    let newPos;
    switch (elems.length) {
      case 1:
        if (itemIndex === index) {
          newPos = 0
        }
        break;
      case 2:
        if (itemIndex === index) {
          newPos = 0
        } else {
          newPos = 1
        }
        break;
      case 3:
        if (index === 0) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === 1) {
            newPos = 1
          } else if (itemIndex === 2) {
            newPos = -1
          }
        } else if (index === 1) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === 2) {
            newPos = 1
          } else if (itemIndex === 0) {
            newPos = -1
          }
        } else if (index === 2) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === 1) {
            newPos = -1
          } else if (itemIndex === 0) {
            newPos = 1
          }
        }
        break;
      case 4:
        if (index === 0) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === index + 1) {
            newPos = 1
          } else if (itemIndex === elems.length - 1) {
            newPos = -1
          }
          else {
            newPos = "oculto";
          }
        } else if (index === 3) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === elems.length - elems.length) {
            newPos = 1
          } else if (itemIndex === index - 1) {
            newPos = -1
          } else {
            newPos = "oculto";
          }
        } else {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === index + 1) {
            newPos = 1
          } else if (itemIndex === index - 1) {
            newPos = -1
          } else {
            newPos = "oculto";
          }
        }
        break;
      default:
        if (index === 0) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === index + 1) {
            newPos = 1
          } else if (itemIndex === index + 2) {
            newPos = 2
          } else if (itemIndex === elems.length - 1) {
            newPos = -1
          } else if (itemIndex === elems.length - 2) {
            newPos = -2
          } else {
            newPos = "oculto";
          }
        } else if (index === 1) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === index + 1) {
            newPos = 1
          } else if (itemIndex === index + 2) {
            newPos = 2
          } else if (itemIndex === index - 1) {
            newPos = -1
          } else if (itemIndex === elems.length - 1) {
            newPos = -2
          } else {
            newPos = "oculto";
          }
        } else if (index === elems.length - 1) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === 0) {
            newPos = 1
          } else if (itemIndex === 1) {
            newPos = 2
          } else if (itemIndex === elems.length - 2) {
            newPos = -1
          } else if (itemIndex === elems.length - 3) {
            newPos = -2
          } else {
            newPos = "oculto";
          }
        } else if (index === elems.length - 2) {
          if (itemIndex === index) {
            newPos = 0
          } else if (itemIndex === elems.length - 1) {
            newPos = 1
          } else if (itemIndex === 0) {
            newPos = 2
          } else if (itemIndex === elems.length - 3) {
            newPos = -1
          } else if (itemIndex === elems.length - 4) {
            newPos = -2
          } else {
            newPos = "oculto";
          }
        } else {
          if (itemIndex === index) {
            newPos = 0;
          } else if (itemIndex === (index + 1)) {
            newPos = 1;
          } else if (itemIndex === (index + 2)) {
            newPos = 2;
          } else if (itemIndex === (index - 1)) {
            newPos = -1;
          } else if (itemIndex === (index - 2)) {
            newPos = -2;
          } else {
            newPos = "oculto";
          }
        }
    }
    return newPos;
  }

  const handleLista = (newActive, pacienteUid) => {
    seleccionarPaciente(pacienteUid)
    setSeleccionado(pacienteUid)

    const newActiveIndex = elems.indexOf(newActive);

    elems.forEach(item => {
      let itemIndex = elems.indexOf(item);
      item.dataset.pos = reasignarPosicion(itemIndex, newActiveIndex)
    });
    
  };

  useEffect(() => {

    const newArrayCarrusel = asignarPosiciones(pacientes);
    setArrayCarrusel(newArrayCarrusel);
    setSeleccionado(pacientes[0].uid)

  }, [pacientes]);


  return (
    <div>
      <div className="carousel">
        <ul className="carousel__list" >
          {arrayCarrusel.map((value, index) => (
            <li key={index} className="carousel__item" data-pos={value.pos}
              onClick={(e) => handleLista(e.target, value.uid)}>
              <Card
                paciente={value}
                largo={arrayCarrusel.length}
                index={arrayCarrusel.indexOf(value) + 1}
                seleccionado={seleccionado}
              />
            </li>))}
        </ul>
      </div>
    </div>
  )
}

export default Carousel;